export default __webpack_public_path__ + "static/media/bar.222248c0.png";